export enum IRolePermissionAccess {
  NOT_ACCESSIBLE = 1,
  ACCESSIBLE = 2,
}
export enum IModalKeyEnums {
  VIDEO_CALL = "videoCall",
  APPOINTMENT = "appointment",
  AVAILABILITY_SETTING = "availabilitySetting",
  DOCTOR = "doctor",
  IP_DASHBOARD = "ipDashboard",
  MEDICAL_RECORD = "medicalRecord",
  NOTIFICATION = "notification",
  PRESCRIPTION = "prescription",
  PATIENT_MEMBER = "patientMember",
  PRESCRIPTION_ATTRIBUTES = "prescriptionAttributes",
  PRESCRIPTION_TEMPLATE = "prescriptionTemplate",
  SCHEDULE_SLOTS = "scheduleSlots",
  SUPPORT_TICKET = "supportTicket",
  UPLOAD_DOCUMENT = "uploadDocument",
  USER = "user",
  CHAT = "chat",
  DOCTOR_REVIEW = "doctorReview",
  OPD_RECEPTION_WEB = "opdReceptionWeb",
  REPORT = "reports",
  DASHBOARD = "dashboard",
}

export enum IAgoraTokenForVideoCallPermissionEnums {
  GENERATE_VIDEO_CALL_TOKEN_FOR_APP = "generateVideoCallTokenForAPP",
  GENERATE_VIDEO_CALL_TOKEN_FOR_WEB = "generateVideoCallTokenForWeb",
  SEND_VIDEO_CALL_NOTIFICATION = "sendVideoCallNotification",
}

export enum IAppointmentPermissionEnums {
  BOOKING_STATUS = "bookingStatus",
  CANCEL_APPOINTMENT = "cancelAppointment",
  CREATE_APPOINTMENT = "createAppointment",
  RESCHEDULE_APPOINTMENT = "rescheduleAppointment",
  SEARCH_APPOINTMENT = "searchAppointment",
  VIEW_APPOINTMENTS = "viewAppointments",
}

export enum IFeaturePermissionEnums {
  COMPLETED_CONSULTATION_SUMMARY = "completedConsultationSummary",
  HOSPITAL_SUMMARY = "hospitalSummary",
  PATIENT_SUMMARY = "patientSummary",
}

export enum IAvailabilitySettingPermissionEnums {
  CREATE_AVAILABILITY = "createAvailability",
  DELETE_AVAILABILITY = "deleteAvailability",
  UPDATE_AVAILABILITY = "updateAvailability",
  VIEW_AVAILABILITY_LIST = "viewAvailabilityList",
}

export enum IChatPermissionEnums {
  VIEW_APPOINTMENT_CHAT_LIST = "viewAppointmentChatList",
  VIEW_IP_DASHBOARD_CHAT_LIST = "viewIPDashboardChatList",
}

export enum IDoctorReviewPermissionEnums {
  DELETE_REVIEW = "deleteReview",
  REPLY_REVIEWS = "replyReviews",
  VIEW_REVIEWS = "viewReview",
}
export enum IDoctorPermissionEnums {
  GET_DOCTOR_LINKED_CLINICS = "getDoctorLinkedClinics",
  GET_DOCTOR_PROFILE_BY_DOCTOR = "getDoctorProfileByDoctor",
  VIDEO_REVIEW_LIST = "videoReviewList",
}

export enum IIPDashboardPermissionEnums {
  ADMIT_PATIENT = "admitPatient",
  DISCHARGE_AND_EDIT_ADMITTED_PATIENT = "dischargeAndEditAdmittedPatient",
  SEARCH_ADMIT_PATIENT = "searchAdmitPatient",
  VIEW_ADMITTED_PATIENT_DETAILS = "viewAdmittedPatientDetails",
  VIEW_IP_DASHBOARD = "viewIPDashboard",
  VIEW_ROOM_AND_BEDS_OF_A_HOSPITAL = "viewRoomAndBedsOfAHospital",
}

export enum IReportsPermissionEnums {
  APPOINTMENT_BOOKED_BY_FILTER = "appointmentBookedByFilter",
  APPOINTMENT_REPORTS = "appointmentReports",
  MARK_STAFF_ACTIVE_INACTIVE = "markStaffActiveInactive",
  DOCTOR_SCHEDULE_REPORTS = "doctorScheduleReports",
  DOCTOR_STAFF_REPORTS = "doctorStaffReports",
  MEDICAL_PARTNER_REPORTS = "medicalPartnerReports",
}

export enum IMedicalRecordPermissionEnums {
  VIEW_MEDICAL_RECORDS = "viewMedicalRecords",
}

export enum IInAppNotifiationsPermissionEnums {
  IN_APP_NOTIFICATIONS = "inAppNotifiations",
}
export enum IPatientMemberPermissionEnums {
  VIEW_PATIENT_MEMBER_LIST = "viewPatientMemberList",
}
export enum IScheduleSlotsPermissionEnums {
  VIEW_SCHEDULE_SLOT_BY_DOCTOR = "viewScheduleSlotByDoctor",
}
export enum IUploadDocumentEnums {
  UPLOAD_TO_S3 = "uploadToS3",
}
export enum IPrescriptionAttributesPermissionEnums {
  SEARCH_PRESCRIPTION_ATTRIBUTES = "searchPrescriptionAttributes",
}
export enum IPrescriptionPermissionEnums {
  ACTIVE_PRESCRIPTION = "activePrescription",
  CREATE_PRESCRIPTION = "createPrescription",
  LAST_PRESCRIPTION = "lastPrescription",
  SAVE_PRESCRIPTION_MEDICAL_RECORD = "savePrescriptionMedicalRecord",
  UPDATE_PRESCRIPTION = "updatePrescription",
  SEARCH_MEDICINE = "searchMedicine",
  SEARCH_TEST = "searchTest",
}
export enum IPrescriptionTemplatePermissionEnums {
  CREATE_PRESCRIPTION_TEMPLATE = "createPrescriptionTemplate",
  DELETE_PRESCRIPTION_TEMPLATE = "deletePrescriptionTemplate",
  UPDATE_PRESCRIPTION_TEMPLATE = "updatePrescriptionTemplate",
  VIEW_PRESCRIPTION_TEMPLATE = "viewPrescriptionTemplate",
}

export enum ISupportTicketPermissionEnums {
  CREATE_SUPPORT_TICKET = "createSupportTicket",
  VIEW_SUPPORT_TICKET_LIST = "viewSupportTicketList",
}

export enum IOPDReceptionWebPermissionEnums {
  BILL_RECIEPT = "billReciept",
  BLOCK_PATIENT_FOR_BOOKING_APPOINTMENT = "blockPatientForBookingAppointment",
  RECEIVE_PAYMENT = "receivePayment",
  VIEW_OPD_RECEPTION = "viewOPDReception",
}

export enum IUserPermissionEnums {
  BLOCK_PATIENT = "blockPatient",
  CREATE_PATIENT_BY_DOCTOR = "createPatientByDoctor",
  FETCH_DETAILS_FOR_CHAT = "fetchDetailsForChat",
  LOGOUT = "logout",
  OTP_TO_CREATE_PATIENT_BY_DOCTOR = "otpToCreatePatientByDoctor",
  REFRESH_PAGE = "refreshPage",
  SEARCH_PATIENT = "searchPatient",
  SEARCH_USER = "searchUser",
  VIEW_DOCTOR_TEAM = "viewDoctorTeam",
}
